import React, { useRef, useEffect } from "react"
import { TranscriptPanelProps } from "./types"



export const TranscriptPanel: React.FC<TranscriptPanelProps> = ({
    viewLiveTranscript,
    connected,
    isMyraSpeaking,
    isAiTyping,
    isListening,
    isMicOn,
    messages,
}) => {
    const transcriptionEndRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (transcriptionEndRef.current) {
            transcriptionEndRef.current.scrollIntoView({ behavior: "smooth" })
        }
    }, [messages])

    return (
        <div
            className={`h-4/6 md:h-full flex-col absolute left-6 bottom-6 z-20  
                        md:relative md:left-0 md:bottom-0 bg-white border-l border-gray-200 rounded-lg 
                        transition-all duration-500 transform hidden sm:flex
                        ${viewLiveTranscript
                    ? "opacity-100 translate-y-0 pointer-events-auto w-4/5 sm:w-72 md:w-60 lg:w-96"
                    : "opacity-0 -translate-y-4 pointer-events-none w-0"
                }`}
        >
            {viewLiveTranscript && (
                <>
                    <div className="px-6 py-4">
                        <div className="flex flex-col items-center justify-between">
                            <h2 className="text-xl font-semibold text-gray-900">Live Transcription</h2>
                            <div className="flex items-center gap-4">
                                {connected && (
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                        <span className="text-xs text-gray-500">Connected</span>
                                    </div>
                                )}
                                {isMyraSpeaking && (
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
                                        <span className="text-xs text-gray-500">Myra speaking...</span>
                                    </div>
                                )}
                                {isAiTyping && !isMyraSpeaking && (
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                                        <span className="text-xs text-gray-500">AI responding...</span>
                                    </div>
                                )}
                                {isListening && isMicOn && !isAiTyping && !isMyraSpeaking && (
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                                        <span className="text-xs text-gray-500">Listening...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="flex-1 px-6 py-4 space-y-4 overflow-y-auto">
                        {messages.map((msg) => (
                            <div key={msg.id} className="space-y-2">
                                <div
                                    className={`text-sm font-medium ${msg.from === "user" ? "text-right" : "text-left"} text-gray-900`}
                                >
                                    {msg.from === "user" ? "You" : "Myra"}
                                </div>
                                <div
                                    className={`text-sm ${msg.from === "user"
                                        ? "bg-indigo-100 text-gray-800 ml-8 text-left"
                                        : "bg-gray-100 text-gray-700 mr-8 text-left"
                                        } rounded-lg px-4 py-3`}
                                >
                                    {msg.content}
                                </div>
                            </div>
                        ))}

                        {isAiTyping && (
                            <div className="space-y-2">
                                <div className="text-sm font-medium text-left text-gray-900">Myra</div>
                                <div className="px-4 py-3 mr-8 text-sm text-left text-gray-700 bg-gray-100 rounded-lg">
                                    <div className="flex items-center space-x-2">
                                        <div className="flex space-x-1">
                                            <div
                                                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                                                style={{ animationDelay: "0ms" }}
                                            ></div>
                                            <div
                                                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                                                style={{ animationDelay: "150ms" }}
                                            ></div>
                                            <div
                                                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                                                style={{ animationDelay: "300ms" }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div ref={transcriptionEndRef} />
                    </div>
                </>
            )}
        </div>
    )
}

